import React, { useState, useEffect, useCallback } from "react";
import { message } from "antd";

import { downloadFile } from "../../../components/util";
import { WrappedFormBehaviorType } from "./formBehaviorType";
import { QmDimensionTable } from "../components/qmTable";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
// import { IBehaviorType, IBehaviorTypeListResponse } from "./types";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";
import { Utilitaries } from "../../../business";
import { remove, select } from "../actions/dimensionsAndType";
import { IBehaviorType, IBehaviorTypeListResponse } from "./types";

const listName = "tipos_comportamentos";
const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "designacao:150:Tipo de conhecimento;descricao:650:Descrição;",
    titulo: "Tipos de comportamentos",
};

export function BehaviorType() {
    const [dataSource, setDataSource] = useState<IBehaviorType[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IBehaviorType | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    /** get tipos habilidades from the server */
    const getBehaviorType = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IBehaviorTypeListResponse) => {
                const list: IBehaviorType[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                        descricao: typeof item.descricao === "object" ? "" : item.descricao,
                        versao: typeof item.versao === "object" ? "" : item.versao,
                    };
                });

                setDataSource(data);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de conhecimento.");
            })
            .finally(() => {
                setLoadingData(false);
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        getBehaviorType();
    }, [getBehaviorType]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            getBehaviorType();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IBehaviorType) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            getBehaviorType();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                getBehaviorType();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    /** for search results in table */

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IBehaviorType, string[]>>,
        sorter: SorterResult<IBehaviorType>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }

    const columns: ColumnProps<IBehaviorType>[] = [
        {
            title: "Designação",
            dataIndex: "designacao",
            width: "30%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Descrição",
            dataIndex: "descricao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("descricao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_tipo_comportamento)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];
    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_tipo_comportamento}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormBehaviorType onClose={handleCloseNew} />}
            {editRow && <WrappedFormBehaviorType record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
